export const GINO_QUERY_KEYS = {
  GINO_CREDITS: ["gino-credits"],
  GINO_ADDONS: ["gino-addons"],
  DIRECT_CHAT_ROOM: ["direct-chat-room"],
  CHAT_MESSAGES: (chatId: string) => ["chat-messages", chatId] as const,
  CHAT_LIST: ["chat-list"] as const,
} as const;
